import React, { useRef, useCallback, useState, useEffect } from "react";

const useTimer = () => {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const fn = useCallback((callback, timeout = 0) => {
    if (timer.current !== null) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      callback();
    }, timeout);
  }, []);

  const clearTimeoutHandler = () => {
    if (timer.current !== null) {
      clearTimeout(timer.current);
    }
  };

  useEffect(() => {
    return () => {
      clearTimeoutHandler();
    };
  }, []);

  return { fn, clearTimeoutHandler };
};

export default useTimer